module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main situation"
  }, [(_vm.crumbList && _vm.crumbList.length) ? _c('div', {
    staticClass: "crumb"
  }, [_vm._l((_vm.crumbList), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "crumb_item",
      on: {
        "click": _vm.closeMask
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "order_list",
    staticStyle: {
      "display": "flex"
    }
  }, _vm._l((_vm.myAccidentList), function(item, index) {
    return _c('span', {
      key: ('accidentList_' + index),
      staticClass: "crumb_item bg_eee",
      class: {
        activeCrumb: item.recordNo == _vm.baseInfo.recordNo
      },
      on: {
        "click": function($event) {
          return _vm.reStartMask(item.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.recordNo) + "\n\t\t\t\t\t"), _c('img', {
      staticClass: "close_img",
      attrs: {
        "src": require("../../assets/images/icon/home_tab_icon_close.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.doCancel(item.id, index)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "jumpBtn"
  }, [_c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(0)
      }
    }
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(1)
      }
    }
  }, [_vm._v("人员信息")]), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(2)
      }
    }
  }, [_vm._v("话术模板")]), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(3)
      }
    }
  }, [_vm._v("上传文书")]), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(4)
      }
    }
  }, [_vm._v("返回凭证")])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "leftContent input_new_style",
    class: [_vm.fullVideo ? 'fullVideoClass_left' : 'original_left']
  }, [_c('el-collapse', {
    model: {
      value: (_vm.activeNamesFirst),
      callback: function($$v) {
        _vm.activeNamesFirst = $$v
      },
      expression: "activeNamesFirst"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "基本信息",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("违法处理地点")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.organizationId),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "organizationId", $$v)
      },
      expression: "baseInfo.organizationId"
    }
  }, _vm._l((_vm.daduiLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xwdd"),
      attrs: {
        "label": item.fullName,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("违法处理单位")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.handleOrganizationId),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "handleOrganizationId", $$v)
      },
      expression: "baseInfo.handleOrganizationId"
    }
  }, _vm._l((_vm.daduiLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_gzdw"),
      attrs: {
        "label": item.fullName,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("经办人1")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.firstOperatorId),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "firstOperatorId", $$v)
      },
      expression: "baseInfo.firstOperatorId"
    }
  }, _vm._l((_vm.userLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xwr1"),
      attrs: {
        "label": item.realname,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("经办人2")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.secondOperatorId),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "secondOperatorId", $$v)
      },
      expression: "baseInfo.secondOperatorId"
    }
  }, _vm._l((_vm.userLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xwr2"),
      attrs: {
        "label": item.realname,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("违法处理时间")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "disabled": _vm.disabled_edit,
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.baseInfo.handleTime),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "handleTime", $$v)
      },
      expression: "baseInfo.handleTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("案件类型")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_vm._v("简易程序")])])])])])])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNamesSecond),
      callback: function($$v) {
        _vm.activeNamesSecond = $$v
      },
      expression: "activeNamesSecond"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "人员信息",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("证件类型")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfo.cardType),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "cardType", $$v)
      },
      expression: "userInfo.cardType"
    }
  }, _vm._l((_vm.cardTypeLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_zjlx"),
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("人大代表/政协委员")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfo.specialStatus),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "specialStatus", $$v)
      },
      expression: "userInfo.specialStatus"
    }
  }, _vm._l((_vm.rdorzxLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_rddb/zxwy"),
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("身份证号")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfo.idCardNo),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "idCardNo", $$v)
      },
      expression: "userInfo.idCardNo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("被询问人姓名")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfo.realName),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "realName", $$v)
      },
      expression: "userInfo.realName"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("性别")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfo.sex),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "sex", $$v)
      },
      expression: "userInfo.sex"
    }
  }, _vm._l((_vm.sexTypeLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xb"),
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("民族")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfo.nation),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "nation", $$v)
      },
      expression: "userInfo.nation"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("出生日期")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfo.birthday),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "birthday", $$v)
      },
      expression: "userInfo.birthday"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("联系方式")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfo.phone),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "phone", $$v)
      },
      expression: "userInfo.phone"
    }
  })], 1)])])])])])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNamesThird),
      callback: function($$v) {
        _vm.activeNamesThird = $$v
      },
      expression: "activeNamesThird"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "话术模板",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, _vm._l((_vm.transcripts), function(item, index) {
    return _c('div', {
      key: (index + "_xwbj"),
      staticClass: "big_case"
    }, [(item.operateType != 'REMOVE') ? [_c('ul', {
      staticClass: "ul_case"
    }, [_c('li', [_c('span', [_vm._v("问：")]), _c('el-input', {
      staticClass: "my_input",
      attrs: {
        "placeholder": "请输入",
        "type": "textarea",
        "rows": 3,
        "disabled": _vm.disabled_edit
      },
      on: {
        "change": function($event) {
          return _vm.onChengeQ(index)
        }
      },
      model: {
        value: (item.question),
        callback: function($$v) {
          _vm.$set(item, "question", $$v)
        },
        expression: "item.question"
      }
    })], 1), _vm._v(" "), (item.answerType == 'label') ? _c('li', [_c('span', [_vm._v("答：")]), _c('el-input', {
      attrs: {
        "placeholder": "请输入",
        "type": "textarea",
        "rows": 1,
        "disabled": _vm.disabled_edit
      },
      on: {
        "change": function($event) {
          return _vm.onChengeQ(index)
        }
      },
      model: {
        value: (item.answer),
        callback: function($$v) {
          _vm.$set(item, "answer", $$v)
        },
        expression: "item.answer"
      }
    })], 1) : (item.answerType == 'select') ? _c('li', [_c('span', [_vm._v("答：")]), _vm._v(" "), _c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请选择",
        "disabled": _vm.disabled_edit,
        "filterable": ""
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (item.answer),
        callback: function($$v) {
          _vm.$set(item, "answer", $$v)
        },
        expression: "item.answer"
      }
    }, _vm._l((JSON.parse(item.oriAnswer)), function(an) {
      return _c('el-option', {
        key: (an + "_hbt"),
        attrs: {
          "label": an,
          "value": an
        }
      })
    }), 1)], 1) : _vm._e()]), _vm._v(" "), (!_vm.disabled_edit) ? _c('ul', {
      staticClass: "ul_contor"
    }, [_c('li', [_c('i', {
      staticClass: "el-icon-refresh",
      on: {
        "click": function($event) {
          return _vm.onCutQ(index)
        }
      }
    })]), _vm._v(" "), _c('li', [_c('i', {
      staticClass: "el-icon-plus",
      on: {
        "click": function($event) {
          return _vm.onAddQ(index)
        }
      }
    })]), _vm._v(" "), _c('li', [_c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          return _vm.onDeletaQ(index, item)
        }
      }
    })])]) : _vm._e()] : _vm._e()], 2)
  }), 0)])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNamesForth),
      callback: function($$v) {
        _vm.activeNamesForth = $$v
      },
      expression: "activeNamesForth"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "上传文书",
      "name": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t上传文书\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), (!_vm.disabled_edit) ? _c('span', {
    staticStyle: {
      "margin-right": "30px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addScan(11)
      }
    }
  }, [_vm._v("添加警告文书")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addScan(7)
      }
    }
  }, [_vm._v("添加违法文书")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wholeAcccindentClass"
  }, [_c('div', {
    staticClass: "accidentImages"
  }, _vm._l((_vm.clericalFiles), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "images"
    }, [(item.penaltiesImage) ? _c('div', {
      staticClass: "img-box"
    }, [_c('img', {
      staticClass: "rotate_image",
      attrs: {
        "src": _vm.getImageUrl(item.penaltiesImage)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [(!_vm.disabled_edit) ? _c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          return _vm.deleteImg(index, item.ucode)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "el-icon-zoom-in",
      on: {
        "click": function($event) {
          return _vm.previewImg(item.penaltiesImage)
        }
      }
    })])]) : _c('div', {
      staticClass: "img-box"
    }, [_c('div', {
      staticClass: "img-mask-no"
    }, [(!_vm.disabled_edit) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('i', {
      staticClass: "el-icon-folder-add",
      staticStyle: {
        "position": "relative",
        "margin-right": "20px",
        "font-size": "30px",
        "overflow": "hidden"
      }
    }, [_c('input', {
      staticClass: "upload-img",
      attrs: {
        "type": "file",
        "accept": ".png,.jpg,.jpeg"
      },
      on: {
        "change": function($event) {
          return _vm.updateImg(item.type, index, item, $event)
        }
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "el-icon-printer",
      staticStyle: {
        "font-size": "30px"
      },
      on: {
        "click": function($event) {
          return _vm.statrScan(index, item)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("扫描文书")])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "wholeAcccindentClass",
    staticStyle: {
      "margin-top": "25px",
      "display": "none"
    }
  }, [_c('dwt', {
    attrs: {
      "is_scan": _vm.is_scan,
      "roomId": _vm.roomId,
      "is_ucode": _vm.is_ucode,
      "is_fileType": _vm.is_fileType
    },
    on: {
      "changeScanState": _vm.changeScanState
    }
  })], 1)])], 2)], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNamesFifth),
      callback: function($$v) {
        _vm.activeNamesFifth = $$v
      },
      expression: "activeNamesFifth"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "返回凭证",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "retrun_case"
  }, [_vm._l((_vm.evidences), function(item, index) {
    return [(item.indexOf('.mp4') == -1) ? _c('img', {
      key: index,
      staticClass: "retrun_image",
      attrs: {
        "src": _vm.getImageUrl(item) + '&time=' + new Date().getTime()
      },
      on: {
        "click": function($event) {
          return _vm.previewImg(item)
        }
      }
    }) : _c('img', {
      key: index,
      staticClass: "retrun_image",
      attrs: {
        "src": require("../../assets/images/pics/player.png")
      },
      on: {
        "click": function($event) {
          return _vm.previewImg(item)
        }
      }
    })]
  }), _vm._v(" "), (_vm.certificateFileUrl) ? _vm._l((_vm.certificateFileUrl), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "retrun_image rotate_image",
      attrs: {
        "src": _vm.getImageUrl(item.certificateImage) + '&time=' + new Date().getTime()
      },
      on: {
        "click": function($event) {
          return _vm.previewImg(item.certificateImage)
        }
      }
    })
  }) : (_vm.signFileImage) ? _vm._l((_vm.signFileImage), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "retrun_image rotate_image",
      attrs: {
        "src": _vm.getImageUrl(item.certificateImage) + '&time=' + new Date().getTime()
      },
      on: {
        "click": function($event) {
          return _vm.previewImg(item.certificateImage)
        }
      }
    })
  }) : _vm._e()], 2)])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "66px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.certificateFileUrl) ? [_c('div', {
    ref: "print"
  }, _vm._l((_vm.certificateFileUrl), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "retrun_image",
      staticStyle: {
        "width": "100%",
        "height": "auto"
      },
      attrs: {
        "src": _vm.getImageUrl(item.certificateImage) + '&time=' + new Date().getTime()
      }
    })
  }), 0)] : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "rightContent",
    class: {
      fullVideoClass_right: _vm.fullVideo
    }
  }, [(_vm.trtcStatus) ? _c('div', {
    staticClass: "left no_video_text"
  }, [(!_vm.disabled_edit) ? _c('span', [(_vm.remoteStatus == 'success' && !_vm.hasLocal) ? _c('el-button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "success"
    }
  }, [_vm._v("用户在线")]) : _vm._e(), _vm._v(" "), (_vm.remoteStatus == 'danger' && !_vm.list.length) ? _c('el-button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("用户离线")]) : _vm._e()], 1) : _vm._e()]) : _c('div', {
    staticClass: "left"
  }, [(_vm.videoBtnShow) ? _c('div', {
    staticClass: "videoBtnZone"
  }, [(!_vm.disabled_edit) ? _c('span', {
    attrs: {
      "id": "myBtnCase2"
    }
  }, [(_vm.remoteStatus == 'success' && !_vm.hasLocal) ? _c('el-button', {
    directives: [{
      name: "preventReClick",
      rawName: "v-preventReClick",
      value: (5000),
      expression: "5000"
    }],
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.getRoom
    }
  }, [_vm._v("视频呼叫")]) : _vm._e(), _vm._v(" "), (_vm.remoteStatus == 'danger' && !_vm.list.length) ? _c('el-button', {
    directives: [{
      name: "preventReClick",
      rawName: "v-preventReClick",
      value: (5000),
      expression: "5000"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.notInRoom
    }
  }, [_vm._v("视频呼叫")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.videoState == 0),
      expression: "videoState == 0"
    }],
    staticClass: "display-flex-between—new",
    staticStyle: {
      "margin-top": "478px"
    }
  }, [(_vm.localStream) ? _c('div', {
    staticClass: "userlist local",
    class: [_vm.myTempIndex === null ? _vm.myMainVideo : ''],
    attrs: {
      "id": "warp myLocal"
    },
    on: {
      "click": function($event) {
        return _vm.switchLocalMain1($event)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "local_stream"
    }
  }, [(_vm.list.length) ? _c('div', {
    staticClass: "role1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.muteLocalAudio.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticClass: "policeMuteClass",
    attrs: {
      "src": _vm.isAudio ? require('../../assets/images/pics/icon_microphone2_sel.png') : require('../../assets/images/pics/icon_microphone2_nor.png')
    }
  }), _vm._v(" "), _c('span', [_vm._v("交警")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isVedio),
      expression: "!isVedio"
    }],
    staticClass: "maskable",
    attrs: {
      "id": "mask"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.list.length && _vm.showPolice) ? _c('div', {
    staticClass: "userlist bg-white remote police",
    attrs: {
      "id": "warp"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t交警\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "userlist remoteClass remote user",
      class: [_vm.myTempIndex === index ? _vm.myMainVideo : '']
    }, [(item.remoteStream) ? _c('div', {
      staticClass: "distant-stream",
      attrs: {
        "id": item.id
      },
      domProps: {
        "innerHTML": _vm._s(item.remoteStream)
      }
    }) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "display-flex margin-top-15"
  }, [(!_vm.videoBtnShow) ? _c('div', {
    staticClass: "myBtn",
    on: {
      "click": _vm.leaveRoom
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pics/icon_hang_up.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {}, [_vm._v("\n\t\t\t\t\t\t\t\t挂断\n\t\t\t\t\t\t\t")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottomBtns"
  }, [(!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendSignBook
    }
  }, [_vm._v("推送文书")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.seeSignBook
    }
  }, [_vm._v("查看文书")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.printSignBook
    }
  }, [_vm._v("打印文书")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.stopHandle
    }
  }, [_vm._v("处置终止")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.onFinish
    }
  }, [_vm._v("全流程完成")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.closeMask
    }
  }, [_vm._v("返回")]), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    staticStyle: {
      "margin-left": "100px"
    },
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.onSendImages
    }
  }, [_vm._v("重发三证短信")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.onSendMessage
    }
  }, [_vm._v("重发用户短信")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onFirstWS
    }
  }, [_vm._v("首违文书推送")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "80%",
      "title": "话术模板问题",
      "center": "",
      "visible": _vm.dialog_state,
      "close-on-click-modal": false,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_state = $event
      }
    }
  }, _vm._l((_vm.questions), function(item, index) {
    return _c('div', {
      key: (index + "_xwbj"),
      staticClass: "big_case"
    }, [_c('ul', {
      staticClass: "ul_case"
    }, [_c('li', [_c('span', [_vm._v("问：")]), _c('el-input', {
      attrs: {
        "disabled": "",
        "placeholder": "请输入",
        "type": "textarea",
        "rows": 1
      },
      model: {
        value: (item.question),
        callback: function($$v) {
          _vm.$set(item, "question", $$v)
        },
        expression: "item.question"
      }
    })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("答：")]), _c('el-input', {
      attrs: {
        "disabled": "",
        "placeholder": "请输入",
        "type": "textarea",
        "rows": 1
      },
      model: {
        value: (item.answer),
        callback: function($$v) {
          _vm.$set(item, "answer", $$v)
        },
        expression: "item.answer"
      }
    })], 1)]), _vm._v(" "), _c('ul', {
      staticClass: "ul_contor"
    }, [_c('li', {
      staticClass: "ul_li_btn",
      on: {
        "click": function($event) {
          return _vm.onSelectQ(index, item)
        }
      }
    }, [_vm._v("选择")])])])
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "50%",
      "title": "首违文书",
      "center": "",
      "visible": _vm.firstVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "before-close": _vm.onBeforeClose,
      "destroy-on-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.firstVisible = $event
      }
    }
  }, [(_vm.firstVisible) ? _c('FirstWs', {
    key: _vm.componentKey,
    attrs: {
      "componentId": _vm.roomId
    },
    on: {
      "onClose": _vm.onBeforeClose
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d768068","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/weifa/videoEasy.vue
// module id = teJs
// module chunks = 6